export default __webpack_public_path__ + "static/color-interaction-states-icons-light-7844871bb817460b3953b6ee8448f2c56faf09bbb7050fbc7a2907dacc6f4b47.png";